import http from "../../../http-commonv2";

const list = () => {
  return http.get(`/api/v2/users`);
};

const create = (data) => {
  return http.post(`/api/v2/users`, data);
};

const update = ({ id, data }) => {
  return http.put(`/api/v2/users?id=${id}`, data);
};

const deleteById = (id) => {
  return http.delete(`/api/v2/users?id=${id}`);
};

const UsersService = {
  list,
  create,
  update,
  deleteById,
};

export default UsersService;
